export class Sepa {
  id: number = -1;

  name: string = '';
  code: string = '';

  createdAt: string = '';
  updatedAt: string = '';
}
